import styled from 'styled-components';

import { H3 } from '../Heading';

import { size, rgba } from '../layout/helpers';
import { theme } from '../layout/theme';
import { fadeIn, noTransform } from '../layout/keyframes';
import { ImageWrapper } from '../Hero/wrappers';

export const PanelBody = styled.div`
  padding: ${size(3)};
  padding-top: 0;
  overflow: auto;
  flex: 1 1 auto;
  position: relative;
  height: 100%;

  &.is-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.no-padding {
    padding: 0;
  }

  &.fixedWidth {
    ${theme.screens.LtSm} {
      max-width: 90vw;
    }
  }

  ${theme.screens.Md} {
    padding: ${size(5)};
    padding-top: 0;

    ${ImageWrapper} img {
      min-height: 0;
    }
  }
`;

export const Wrapper = styled.div`
  position: fixed;
  z-index: ${theme.layers.panel};
  top: 0;
  right: 0;
  background: ${theme.colors.bg.main};
  height: 100%;
  width: 100%;
  transform: translateX(100%);
  animation:
    ${fadeIn} 125ms ease-in-out,
    ${noTransform} 125ms ease-in-out forwards;
  display: flex;
  flex-direction: column;

  ${theme.screens.Sm} {
    max-width: ${size(60)};
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  }

  ${theme.screens.Md} {
    max-width: ${size(70)};
  }

  &.wide {
    max-width: ${theme.distances.contentMaxWidth};
  }

  &.no-body-padding {
    ${PanelBody} {
      padding: 0;
    }
  }
`;

export const PanelHead = styled.div`
  padding: ${size(3)};
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  justify-content: flex-end;

  &.no-padding {
    padding: 0;
  }

  ${theme.screens.Md} {
    padding: ${size(3)} ${size(5)};
  }

  &.fixedWidth {
    ${theme.screens.LtSm} {
      max-width: 97vw;
    }
  }
`;

export const PanelTitle = styled(H3)`
  font-family: ${theme.font.family.main};
  flex: 1 1 auto;
  padding-right: ${size(3)};

  &.small {
    font-size: 18px;
    font-weight: ${theme.font.weight.regular};
  }
`;

export const PanelClose = styled.button`
  position: relative;
  flex: 0 0 auto;
  font-size: 1.25rem;
  transform-origin: 50% 50%;
  transition: transform 150ms ease;

  &.float {
    position: absolute;
    top: ${size(3)};
    right: ${size(3)};
    z-index: 10;

    &:before {
      background-color: #fff;
      opacity: 1;
    }

    ${theme.screens.LtMd} {
      position: fixed;
      top: ${size(5)};
      right: ${size(5)};
    }
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${size(5)};
    height: ${size(5)};
    border-radius: 50%;
    background-color: ${rgba(theme.colors.bg.alt, 0.05)};
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.95);
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

export const PanelFooter = styled.div`
  flex-shrink: 0;
  padding: ${size(2)} ${size(3)};
  margin-top: auto;

  ${theme.screens.Md} {
    padding: ${size(3)} ${size(5)};
  }
`;

export const UiBlock = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${theme.layers.belowPanel};
  background: rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 125ms linear;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: ${size(1)};
`;
